import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/imgcaptions/piceBox.png'
import _imports_1 from '@/assets/imgcaptions/icon_tianjiasel.png'


const _hoisted_1 = { class: "sharesBox" }
const _hoisted_2 = { class: "shareTitle" }
const _hoisted_3 = { class: "sharePrompt" }
const _hoisted_4 = { class: "sharePeoples" }
const _hoisted_5 = { class: "sharePeopleOneLeft" }
const _hoisted_6 = { class: "peopleInfo" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 0,
  class: "peopleStateNo"
}
const _hoisted_10 = {
  key: 1,
  class: "peopleStateOk"
}
const _hoisted_11 = { class: "sharePeopleOneRight" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "sharePhone" }
const _hoisted_14 = { class: "sharePhoneInvite" }
const _hoisted_15 = { class: "shareExport" }
const _hoisted_16 = { class: "shareExportMain" }
const _hoisted_17 = { class: "shareExportMainInner" }
const _hoisted_18 = { class: "shareExportMain shareExportMainBorder" }
const _hoisted_19 = { class: "shareExportMainInner" }
const _hoisted_20 = {
  src: _imports_1,
  alt: ""
}
const _hoisted_21 = {
  src: _imports_1,
  alt: ""
}

import { ref, onMounted,getCurrentInstance} from 'vue'
import { ElMessage, ElMessageBox, ElLoading } from "element-plus";
import {
    Close,
} from "@element-plus/icons-vue";
import { useRouter } from 'vue-router';
import headPic from '@/assets/aivoice/ico_morentouxiang.svg';
// 引入接口
import newCaptionApi from "@/api/newCaption/index.ts";

export default /*@__PURE__*/_defineComponent({
  __name: 'shareBox',
  props: {
    roles: Array,
    titleText:String,
    id:String,
    },
  emits: ['closeThis'],
  setup(__props, { emit: __emit }) {

const router = useRouter();
let { proxy } = getCurrentInstance()
const props = __props
    const subtitleId=ref()
    const cellphone=ref('')
    const checkList=ref(['1'])
    onMounted(()=>{
        console.log(props.roles)
        console.log(props.id)
        subtitleId.value = router.currentRoute.value.query.subtitleId;
       console.log(subtitleId.value)
       shareListGet()
    })
    // 下载
const Filename=ref('')
const downText=()=>{
    let obj = {
        contents: checkList.value.join(','),
        ext: checkListType.value,
        id:props.id,
    }
    console.log(checkList.value)
    newCaptionApi.TextDownlod(obj.id, obj.contents, obj.ext)
        .then(res => {
            Filename.value = decodeURIComponent(res.headers.get('Filename'))
            console.log(res)
            return res.blob()
        })
        .then(data => {
            
            const fileURL = window.URL.createObjectURL(data); // 创建了

            const link = document.createElement('a'); // 创建一个链接元素开

            link.href = fileURL;
            // link.download = props.titleText.split('.')[0] + '.' + Filename.value.split('.')[1];
            link.download = props.titleText.split('.')[0] + '.' + obj.ext;
            console.log(Filename.value)
            link.click(); // 拟点击下载链接
            window.URL.revokeObjectURL(fileURL);
        })
}
    const shareList=ref([])
    const checkListType=ref('srt')
   
    // 获取分享列表
    const shareListGet=()=>{
        newCaptionApi.shareList(subtitleId.value).then((res)=>{
            console.log(res)
            shareList.value=res.data
        })
    }
// 邀请
const inviteRole=()=>{
    console.log('=========')
    console.log(cellphone.value)
    if(cellphone.value==''){
        return
    }
    const RegCellPhone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
	const  falg=cellphone.value.search(RegCellPhone);
    console.log(falg)
    if(falg==0){
         newCaptionApi.shareTo(subtitleId.value,cellphone.value).then((res)=>{
            console.log(res)
            if(res.code==200){
                shareListGet()
            }
        })
    }else{
        console.log('手机号输入错误')
        ElMessage({
            message: '手机号输入错误',
            type: 'warning',
            plain: true,
        })
    }
   
}
// 取消邀请
const cancel=(shareId:number,index:number)=>{
    newCaptionApi.myCancelsharePut(shareId).then((res)=>{
        console.log(res)
        if(res.code==200){
            shareList.value.splice(index,1)
        }
        
    }).catch(res=>{
        console.log(res)
    })
}

const emit = __emit
const clostFun=()=>{
    emit('closeThis')
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("span", null, "分享项目", -1)),
      _createElementVNode("span", {
        class: "closeBtn",
        onClick: _withModifiers(clostFun, ["stop"])
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_unref(Close))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shareList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "sharePeopleOne",
            key: index
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                (item.avatar!=undefined&&item.avatar!='')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _unref(proxy).getimgUrl+item.avatar,
                      alt: ""
                    }, null, 8, _hoisted_7))
                  : _createCommentVNode("", true),
                (item.avatar==undefined||item.avatar=='' )
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: _unref(headPic),
                      alt: ""
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(item.nickname), 1)
              ]),
              (item.shareStatus=='0')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[5] || (_cache[5] = [
                    _createElementVNode("span", null, "待接受", -1)
                  ])))
                : _createCommentVNode("", true),
              (item.shareStatus=='1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[6] || (_cache[6] = [
                    _createElementVNode("span", null, "已接受", -1)
                  ])))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", {
                onClick: _withModifiers(($event: any) => (cancel(item.shareId,index)), ["stop"])
              }, "取消邀请", 8, _hoisted_12)
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "sharePhoneTitle" }, "通过手机号邀请", -1)),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "请输入手机号",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cellphone).value = $event))
          }, null, 512), [
            [_vModelText, cellphone.value]
          ]),
          _createElementVNode("span", {
            onClick: _withModifiers(inviteRole, ["stop"])
          }, "邀请")
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "shareExportTitle" }, " 导出 ", -1)),
        _createElementVNode("div", _hoisted_16, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "shareExportMainTitle" }, "字幕内容", -1)),
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_checkbox_group, {
              modelValue: checkList.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((checkList).value = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_checkbox, {
                  label: "原文",
                  value: "1"
                }),
                _createVNode(_component_el_checkbox, {
                  label: "译文",
                  value: "2"
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "shareExportMainTitle" }, "文件格式", -1)),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("img", {
                src: _imports_0,
                alt: "",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (checkListType.value='srt'), ["stop"]))
              }, null, 512), [
                [_vShow, checkListType.value!='srt']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_20, null, 512), [
                [_vShow, checkListType.value=='srt']
              ]),
              _createElementVNode("span", {
                style: _normalizeStyle(checkListType.value=='srt'?{'color':'#409eff'}: '')
              }, "srt", 4)
            ]),
            _createElementVNode("div", null, [
              _withDirectives(_createElementVNode("img", {
                src: _imports_0,
                alt: "",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (checkListType.value='txt'), ["stop"]))
              }, null, 512), [
                [_vShow, checkListType.value!='txt']
              ]),
              _withDirectives(_createElementVNode("img", _hoisted_21, null, 512), [
                [_vShow, checkListType.value=='txt']
              ]),
              _createElementVNode("span", {
                style: _normalizeStyle(checkListType.value=='txt'?{'color':'#409eff'}: '')
              }, "txt", 4)
            ])
          ])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"width":"100%"},
          size: "small",
          color: "#207CF6 ",
          dark: _ctx.isDark,
          onClick: _withModifiers(downText, ["stop"])
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [
            _createTextVNode("下载")
          ])),
          _: 1
        }, 8, ["dark"])
      ])
    ]),
    _cache[12] || (_cache[12] = _createStaticVNode("<div class=\"shareMail\" data-v-14418aa7><div class=\"shareMailTop\" data-v-14418aa7><div class=\"shareMailTopLine\" data-v-14418aa7></div><div class=\"shareMailTopTitle\" data-v-14418aa7>发送到邮箱</div><div class=\"shareMailTopLine\" data-v-14418aa7></div></div><div class=\"shareMailInvite\" data-v-14418aa7><input type=\"text\" placeholder=\"请输入手机号\" data-v-14418aa7><span data-v-14418aa7>邀请</span></div></div>", 1))
  ]))
}
}

})